import ".././styles/Rental.css";
import banquethallpic from ".././assets/banquethall.jpg";
import { Link } from "react-router-dom";

function BanquetHall() {
    return (
        <div className="container">
            <div className="rental-section">
                <div className="rental-details">
                    <div className="rental-image-container">
                        <img className="rental-image" src={banquethallpic} alt="Image of the banquet hall."></img>
                    </div>
                    <div className="rental-description">
                        <h2 className="rental-title">Banquet Hall</h2>
                        <p>
                            The Banquet Hall is a spacious, a multi-purpose room available for rent at the PCCM. 
                            It’s well-suited for events such as weddings, socials, anniversaries, christening, birthdays, conferences, corporate meetings, fundraisers, and special occasions.
                            The hall has a capacity of 400 people that can accommodate all of your needs.
                            <br></br><br></br>
                            If you want to inquire about the Banquet Hall, please contact us at <i>(204) 775-4928</i>. If you want to book the Banquet Hall, 
                            please contact us at <i>president@thenewpccm.ca</i>. Alternatively, you can connect with us on our <a href="/contact" className="redirect-page">Contact Us Page</a>.
                        </p>
                        {/* <Link className="rental-agreement-btn">View Rental Agreement &#62;</Link> */}
                    </div>
                </div>

                <div className="rental-features-details">
                    {/* <div className="rental-features-details-child">
                        <h3>Features</h3>
                        <ul>
                            <li><p>Call for more details</p></li>
                        </ul>
                    </div> */}
                    <div className="rental-features-details-child" id="rates-section">
                        <h3>Rates</h3>
                        <ul>
                            <li><p><span className="left">Daytime (6AM - 6PM):</span><span className="right"> $50 per hour</span></p></li>
                            <li><p><span className="left">Evening (6PM - 1AM):</span><span className="right"> $100 per hour</span></p></li>
                        </ul>
                        <h3 className="socan">SOCAN Fee</h3>
                        <ul>
                            <li><p><span className="left">1-100 Guests:</span><span className="right"> $22.75</span></p></li>
                            <li><p><span className="left">101-200 Guests:</span><span className="right"> $34.15</span></p></li>
                            <li><p><span className="left">over 200 Guests:</span><span className="right"> $51.20</span></p></li>
                        </ul>
                    </div>
                    <div className="rental-features-details-child" id="additionals-section">
                        <h3>Applicable Fees</h3>
                        <ul>
                            <li><p><span className="left">Damage Deposit:</span><span className="right"> $300</span></p></li>
                            <li><p><span className="left">Set-up/Cleaning (6AM - 6PM):</span><span className="right"> $150</span></p></li>
                            <li><p><span className="left">Set-up/Cleaning (6PM - 1AM):</span><span className="right"> $200</span></p></li>
                        </ul>
                        <h3 className="socan">Optional Services</h3>
                        <ul>
                            <li><p><span className="left">Bartenders (2):</span><span className="right"> $136 for 4 hours</span></p></li>
                            <li><p><span className="left">Security Guards (2):</span><span className="right"> $160 for 4 hours</span></p></li>
                        </ul>
                    </div>
                </div>
                <div className="notes-rental">
                    <br></br>
                    <h3>Additional Information</h3>
                    <ul>
                        <li><p><b>All rates subject to 5% GST.</b></p></li>
                        <li><p>Minimum rental is <b>three (3) hours</b> plus one (1) hour free for prep purpose.</p></li>
                        <li><p>Two hours gap between events is observed.</p></li>
                        <li><p>SOCAN Fee is charged when recorded music are being played at the event.</p></li>
                        <li><p>The Rental Agreement must be signed, and the Damage Deposit must be paid to guarantee the booking.</p></li>
                        <li><p>The Damage Deposit are refundable.</p></li>
                    </ul>
                </div>
                {/* <button className="button-1" id="book-button"><h4>Book</h4></button> */}
            </div>
        </div>
    );
}

export default BanquetHall;